export { searchPortals } from './portals';

export type { PortalSearchResponse } from './types';
